import { useCallback } from 'react';
export function useColumnVisibility(hiddenColumns, setHiddenColumns, nonHideableKeys) {
    const isHideable = useCallback((dataKey) => !nonHideableKeys.includes(dataKey), [nonHideableKeys]);
    const isHidden = useCallback((dataKey) => hiddenColumns.includes(dataKey), [hiddenColumns]);
    const toggle = useCallback((dataKey) => {
        if (!isHideable(dataKey))
            return;
        setHiddenColumns(hiddenColumns.includes(dataKey) ? hiddenColumns.filter((key) => key !== dataKey) : [...hiddenColumns, dataKey]);
    }, [hiddenColumns, setHiddenColumns, isHideable]);
    const filterVisible = useCallback((columns) => columns.filter((column) => !isHideable(column.dataKey) || !hiddenColumns.includes(column.dataKey)), [hiddenColumns, isHideable]);
    return { isHidden, toggle, filterVisible };
}
